var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.757,
    height: 40,
    viewBox: "0 0 46.757 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(-1089.77 -384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "university-lecture-svgrepo-com",
    d: "M47.361,55.631H31.074a1.071,1.071,0,1,1,0-2.143H46.289V22.638H3.819V45.184a1.071,1.071,0,1,1-2.143,0V21.566a1.072,1.072,0,0,1,1.071-1.071H47.361a1.072,1.072,0,0,1,1.071,1.071V54.559A1.072,1.072,0,0,1,47.361,55.631Zm-5.81-21.95h-5.5a1.071,1.071,0,0,1,0-2.143h5.5a1.071,1.071,0,0,1,0,2.143Zm-10.478,0H29.031a1.071,1.071,0,1,1,0-2.143h2.043a1.071,1.071,0,0,1,0,2.143Zm10.478-4.47h-11a1.071,1.071,0,0,1,0-2.143h11a1.071,1.071,0,0,1,0,2.143Zm-11-11.436h-11a1.071,1.071,0,1,1,0-2.143h11a1.071,1.071,0,1,1,0,2.143Z",
    transform: "translate(1088.094 368.369)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(1098.98 403.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M86.509,214.209h11.76a1.177,1.177,0,0,0,1.175-1.175v-7.056a1.177,1.177,0,0,0-1.175-1.175H86.509a1.177,1.177,0,0,0-1.175,1.175v7.056a1.175,1.175,0,0,0,1.175,1.175Zm1.175-7.056h9.409v4.7H87.685Z",
    transform: "translate(-85.334 -204.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M94.789,292.486h7.374a1.212,1.212,0,0,0,0-2.353H94.789a1.211,1.211,0,0,0,0,2.353Z",
    transform: "translate(-91.319 -272.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199-2",
    "data-name": "Path 199",
    d: "M95.043,292.486h9.409a1.176,1.176,0,0,0,0-2.353H95.043a1.176,1.176,0,0,0,0,2.353Z",
    transform: "translate(-92.593 -277.104)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.50e4fb19d2faaa55f14c6f2722451002.svg";
export { ForwardRef as ReactComponent };